import type { MessengerMessage, MessengerReplySnapshot } from '@/api/client';

type RawContextAttachment = { type?: string; id?: string; name?: string; date?: string; label?: string };

export type MessengerContextAttachmentPreview = {
  kind: 'project' | 'session' | 'planner';
  title: string;
};

export function getMessengerContextAttachmentPreview(
  raw: MessengerMessage['context_attachments'] | MessengerReplySnapshot['context_attachments'],
): MessengerContextAttachmentPreview | null {
  if (!Array.isArray(raw)) return null;
  const first = raw.find((item): item is RawContextAttachment => Boolean(item && typeof item === 'object'));
  if (!first) return null;

  if (first.type === 'project') {
    return { kind: 'project', title: 'Проект' };
  }
  if (first.type === 'session') {
    return { kind: 'session', title: 'Сессия' };
  }
  if (first.type === 'planner') {
    return { kind: 'planner', title: 'Планер' };
  }
  return null;
}
